import React, {useContext, useEffect} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import {IndividualContext} from "../../individual-context.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import useFetchData from "../../hooks/use-fetch-data.js";
import OtherCharacteristics from "./other-characteristics.jsx";

const Characteristics = () => {
    const {individual, setIndividual, setChanges} = useContext(IndividualContext)

    const {bodyShape, colorEyes, hairType, hairColor, hairSize, individualColors} = useFetchData()

    const onChange = ({target: {id, value}}) => {
        setIndividual(prev => ({...prev, [id]: value}));
        handleChanges()
    }

    const onChangeCustom = (value, id) => {
        setIndividual(prev => ({...prev, [id]: value}))
        handleChanges()
    }


    const handleChanges = () => {
        setChanges(prev => (prev.includes("characteristics") ? prev : [...prev, "characteristics"]))
    }

    return (
        <>
            <Card>
                <Card.Body>
                    <SentryRow>
                        <div className="col-span-3">
                            <InputForm
                                id="height"
                                label="Altura (cm)"
                                value={individual.height}
                                onChange={onChange}
                                type={"number"}
                            />
                        </div>
                        <div className="col-span-3">
                            <SelectComponent
                                id={"color"}
                                value={individual.color}
                                options={individualColors}
                                label={"Cútis"}
                                onChange={(value) => onChangeCustom(value?.value, "color")}
                            />
                        </div>
                        <div className="col-span-3">
                            <SelectComponent
                                id={"bodyShape"}
                                value={individual.bodyShape}
                                options={bodyShape}
                                label={"Compleição"}
                                onChange={(value) => onChangeCustom(value?.value, "bodyShape")}
                            />
                        </div>
                        <div className="col-span-3">
                            <SelectComponent
                                id={"eyes"}
                                value={individual.eyes}
                                options={colorEyes}
                                label={"Cor dos olhos"}
                                onChange={(value) => onChangeCustom(value?.value, "eyes")}
                            />
                        </div>

                        <div className="col-span-4">
                            <SelectComponent
                                id={"hairType"}
                                value={individual.hairType}
                                options={hairType}
                                label={"Tipo dos cabelos"}
                                onChange={(value) => onChangeCustom(value?.value, "hairType")}
                            />
                        </div>
                        <div className="col-span-4">
                            <SelectComponent
                                id={"hairColor"}
                                value={individual.hairColor}
                                options={hairColor}
                                label={"Cor dos cabelos"}
                                onChange={(value) => onChangeCustom(value?.value, "hairColor")}
                            />
                        </div>
                        <div className="col-span-4">
                            <SelectComponent
                                id={"hairSize"}
                                value={individual.hairSize}
                                options={hairSize}
                                label={"Comprimento dos cabelos"}
                                onChange={(value) => onChangeCustom(value?.value, "hairSize")}
                            />
                        </div>
                    </SentryRow>
                </Card.Body>
            </Card>

            <OtherCharacteristics />
        </>
    );
};

export default Characteristics;